import type { Row, RowData, Table } from '@tanstack/react-table';
import { createContext, useContext } from 'react';
import type { DataGridAction } from './types';

export interface DataProviderContext<TData extends RowData> {
  table?: Table<TData>;
  actions: DataGridAction[];
  enableColumnConfiguration: boolean;
  getRowCount: () => number;
  isLoading: boolean;
  isRowHighlighted?: (row: Row<TData>) => boolean;
  isRowClickable?: (row: Row<TData>) => boolean;
  onRowClick?: (row: Row<TData>) => void;
  id?: string;
}

export const Context = createContext<DataProviderContext<any>>({
  actions: [],
  enableColumnConfiguration: false,
  getRowCount: () => 0,
  isLoading: false,
});

export const useDataProvider = () => useContext(Context);
